import { getCommercialIndustryImage } from './commercialIndustryImages';

// Dashboard-only framing. Explore backgrounds and carousel images retain originals.
// A3:1 banner is half the height of each original3:2 illustration at the same width.
// Per-scene focal positions favor heads and working hands over floors/feet.
const COMMERCIAL_UPPER_BODY_POSITION = {
  office: 'center top',
  retail: 'center 8%',
  gas_station: 'center top',
  school: 'center 9%',
  medical: 'center top',
  warehouse: 'center top',
  restaurant: 'center 16%',
  church: 'center 31%',
  mall: 'center 31%',
  bank: 'center 25%',
  stadium: 'center 39%',
  airport: 'center 9%',
};

const MULTIFAMILY_TYPES = new Set([
  'residential', 'multifamily', 'multi_family', 'multi-family',
  'apartment', 'apartments', 'apartment_community',
]);

export const MULTIFAMILY_DASHBOARD_IMAGE = {
  src: '/images/property-dashboards/multifamily-leasing-office.webp',
  alt: 'NECS cleaners and property management staff assisting residents in a multifamily leasing office',
  objectPosition: 'center 14%',
};

export const getPropertyDashboardImage = type => {
  const key = typeof type === 'string' ? type.trim().toLowerCase() : '';
  const commercial = getCommercialIndustryImage(key);
  if (commercial) {
    return { ...commercial, objectPosition: COMMERCIAL_UPPER_BODY_POSITION[key] };
  }
  return MULTIFAMILY_TYPES.has(key) ? MULTIFAMILY_DASHBOARD_IMAGE : null;
};